export const contentTest = {
  contentTest: {
    assetPicker: {
      brief: 'Brief',
      describeYourImageOrVideo: 'Describe your image or video',
      fileTooLarge: 'File must be 100 MB or smaller',
      generate: 'Generate',
      image: 'Image',
      imageOrVideoMax100: 'Image or video (max 100 MB)',
      imageSelected: 'Image selected',
      monksFlowAssetCreation: 'Monks Flow Asset Creation',
      removeSelectedAsset: 'remove selected asset',
      selectKind: 'Select kind',
      upload: 'Upload',
      uploading: 'Uploading…',
      video: 'Video',
      videoSelected: 'Video selected',
    },
    cancelTestDialog: {
      cancelTest: 'Cancel test',
      cancelThisTest: 'Cancel this test?',
      keepRunning: 'Keep running',
      yourTestWillKeepRunning:
        'Your test will keep running in the background — you can view results from the content test list. Cancel anyway?',
    },
    constants: {
      contentTestConfiguration: 'Content test configuration',
      run: 'Run',
      setup: 'Setup',
    },
    contentPhonePreview: {
      yourBrand: 'Your Brand',
    },
    contentTestStatusChip: {
      draft: 'Draft',
      failed: 'Failed',
      inProgress: 'In progress',
      ready: 'Ready',
    },
    contentTestSummaryCard: {
      brandContextUnavailable:
        'The linked analysis could not be read; scored without brand context.',
      caption: 'Caption',
      channel: 'Channel',
      contentTestResults: 'Content test results',
      date: 'Date',
      personas: 'Personas',
      score: 'Score',
      scoredWithBrandContext: 'Scored with brand context from the {{brandName}} analysis',
      scoredWithBrandContextFromAnalysis: 'Scored with brand context from the linked analysis',
    },
    contentTestThumbnail: {
      contentTest: 'Content test',
    },
    detail: {
      contentTest: 'content test',
      retryTheRunOrStart: 'Retry the run, or start a new test.',
      weCouldnTCompleteThis: "We couldn't complete this test.",
    },
    expandableCaption: {
      less: 'less',
      more: 'more',
    },
    instagramPreview: {
      n12453Likes: '12,453 likes',
      noMedia: 'No media',
      originalAudio: 'Original Audio',
      viewProducts: 'View Products',
    },
    keyInsightsGrid: {
      keyInsights: 'Key insights',
      moreInsights: 'More Insights ({{hiddenCount}})',
      showLess: 'Show less',
      strategicTakeawaysFromAudienceFeedback: 'Strategic takeaways from audience feedback',
    },
    linkedInPreview: {
      comment: 'Comment',
      home: 'Home',
      jobs: 'Jobs',
      like: 'Like',
      myNetwork: 'My Network',
      n1h: '1h ·',
      n24Comments12Reposts: '24 comments · 12 reposts',
      notifications: 'Notifications',
      post: 'Post',
      promoted: 'Promoted',
      repost: 'Repost',
      search: 'Search',
      send: 'Send',
    },
    overview: {
      actions: 'Actions',
      actionsFor: 'Actions for {{name}}',
      addYourFirstConceptTo:
        'Add your first concept to see how it resonates with your personas and track results.',
      contentTest: 'Content Test',
      contentTestDeleted: 'Content test deleted',
      contentTestResource: 'content test',
      createContentTest: 'Create Content Test',
      delete: 'Delete',
      evaluateConceptsAgainstPersonasAnd:
        'Evaluate concepts against personas and track results over time.',
      failedToDeleteContentTest: 'Failed to delete content test',
      name: 'Name',
      newContentTest: 'New Content Test',
      owner: 'Owner',
      score: 'Score',
      setup: 'Setup',
      startTestingYourContent: 'Start testing your content',
      thisContentTestAndIts: 'This content test and its results will be permanently deleted.',
      unknown: 'Unknown',
    },
    personaResultCard: {
      audienceMember: 'Audience Member',
      couldNotScoreThisPersona: 'Could not score this persona.',
      directFeedback: 'Direct Feedback',
      noResultRecordedForThis: 'No result recorded for this persona.',
    },
    personaScoreRadar: {
      attention: 'Attention',
      engagement: 'Engagement',
      relevance: 'Relevance',
      resonance: 'Resonance',
      shareability: 'Shareability',
    },
    personaSnapshot: {
      unknownPersona: 'Unknown persona',
    },
    previewMedia: {
      contentMedia: 'content media',
    },
    resultsReport: {
      contentTest: 'Content Test',
      downloadReport: 'Download report',
      exportingPdf: 'Exporting your PDF. This might take a few seconds',
      failedToDownloadPdf: 'Failed to download PDF. Please try again.',
      individualPersonaScores: 'Individual Persona Scores',
      saveToProject: 'Save to project',
      toggleConfigurationPanel: 'Toggle configuration panel',
    },
    runProgressLeftRail: {
      analyzingVisuals: 'Analyzing visuals',
      cancel: 'Cancel',
      couldnTStartScoring: "Couldn't start scoring.",
      gatheringFeedback: 'Gathering feedback',
      generatingReport: 'Generating Report',
      retry: 'Retry',
      runAndGenerateResults: 'Run and generate results',
    },
    runResultLeftRail: {
      newContentTest: 'New content test',
      retry: 'Retry',
      runFailed: 'Run failed',
      weCouldnTCompleteThis: "We couldn't complete this test.",
      yourReportIsReady: 'Your report is ready',
    },
    runSpinnerPane: {
      runningContentTest: 'Running Content Test...',
    },
    setup: {
      brandContextFromAnalysis: 'Brand context from the {{brandName}} analysis',
      captionText: 'Caption / Text',
      chooseAPlatformSetThe:
        'Choose a platform, set the creative and select the personas you want to test with',
      contentTestCreated: 'Content test created',
      failedToCreateContentTest: 'Failed to create content test',
      failedToGenerateAsset: 'Failed to generate asset',
      failedToUploadAsset: 'Failed to upload asset',
      image: 'Image',
      nameThisTest: 'Name this test',
      next: 'Next',
      selectAsset: 'Select asset',
      selectAVideoModel: 'Select a video model',
      personas: 'Personas',
      selectPlatform: 'Select Platform',
      setupYourContentTest: 'Setup your content test',
      title: 'Title',
      titleFromAnalysis: '{{brandName}} - content test',
      variantFormat: 'Variant format',
      video: 'Video',
      videoModel: 'Video model',
      writeACaptionOrText: 'Write a caption or text here ....',
    },
    setupPreviewPane: {
      contentTest: 'Content Test',
    },
    tikTokPreview: {
      following: 'Following',
      forYou: 'For You',
      n125K: '12.5K',
      n452K: '45.2K',
      n8425K: '842.5K',
      originalSound: 'Original Sound - {{displayName}}',
      uploadMediaToPreview: 'Upload media to preview',
    },
    variantCard: {
      strategy: 'Strategy',
      variant: 'Variant {{ordinal}}',
    },
    variantMedia: {
      failedToLoadImage: 'Failed to load image',
      failedToLoadVideo: 'Failed to load video',
      pendingImage: 'Image pending',
      pendingVideo: 'Video pending',
      retry: 'Retry',
    },
    variantsSection: {
      optimizedVariants: 'Optimized Variants',
    },
    xpreview: {
      n24K: '2.4K',
      n2h: '· 2h',
    },
  },
  copyWidget: {
    all: 'All',
    bodyCopy: 'Body Copy',
    bodyImageCopy: 'Body Image Copy',
    bodyTitle: 'Body Title',
    channel: {
      email: 'Email',
      plain: 'Plain',
    },
    collapseSection: 'Collapse section',
    copiedToClipboard: 'Copied "{{header}}" to clipboard',
    copy: 'Copy',
    copyVariation: '\u2014 Variation {{variation}}',
    copySection: 'Copy section',
    copyWidgetUtils: {
      body: 'Body',
      bodyCopy: 'Body Copy',
      bodyImageCopy: 'Body Image Copy',
      bodyTitle: 'Body Title',
      caption: 'Caption',
      footer: 'Footer',
      hashtags: 'Hashtags',
      heroImageCopy: 'Hero Image Copy',
      preheader: 'Preheader',
      primaryCta: 'Primary CTA',
      secondaryCta: 'Secondary CTA',
      subjectLine: 'Subject Line',
      text: 'Text',
    },
    copyThumbnail: {
      copy: 'Copy',
    },
    copyUpdated: 'Copy updated',
    couldNotCopyToClipboard: 'Could not copy to clipboard',
    downloadFormatDropdown: {
      docx: '.docx',
      download: 'Download',
      downloadFormat: 'Download format',
      md: '.md',
      xlsx: '.xlsx',
    },
    editableText: {
      discard: 'Discard changes',
      save: 'Save changes',
    },
    expandSection: 'Expand section',
    failedToSaveEditedCopy: 'Failed to save edited copy',
    footer: 'Footer',
    hashtags: 'Hashtags',
    headline: 'Headline',
    heroImageCopy: 'Hero Image Copy',
    infoMenu: {
      channel: 'Channel',
      close: 'Close',
      date: 'Date',
      enabled: 'Enabled',
      goal: 'Goal',
      model: 'Model',
      na: 'N/A',
      prompt: 'Prompt',
      promptInfo: 'Prompt info',
      qa: 'QA',
      responseStyle: 'Response Style',
    },
    linkDescription: 'Link Description',
    noCopyFound: 'No copy found.',
    preheader: 'Preheader',
    primaryCta: 'Primary CTA',
    responseStyle: {
      balanced: 'Balanced',
      focused: 'Focused',
      imaginative: 'Imaginative',
    },
    sectionHeader: '{{channel}} \u2014 Variation {{variation}}',
    secondaryCta: 'Secondary CTA',
    subjectLine: 'Subject Line',
    unableToDownloadArtifactNot: 'Unable to download: artifact not found',
    viewPromptInfo: 'View prompt info',
  },
  emailFlowWidget: {
    closeEmailSection: 'Close email section',
    codeView: {
      failedToSaveTemplate: 'Failed to save template',
      preHeaderText: 'Pre-Header Text',
      save: 'Save',
      save2: 'save',
      subjectLine: 'Subject Line',
      templateSavedSuccessfully: 'Template saved successfully',
    },
    copyHtml: 'Copy html',
    downloadHtml: 'Download html',
    email: 'Email',
    noDataProvidedForEmailFlowWidget: 'No data provided for EmailFlowWidget',
    noEmailFlowDataAvailable: 'No email flow data available',
    nothingToPublish: 'Nothing to publish',
    previewView: {
      contentLocked: 'Content locked.',
      contentUnlocked: 'Content unlocked.',
      contentUpdated: 'Content updated.',
      contentUpdatedAndLocked: 'Content updated and locked.',
      copyPreHeaderText: 'Copy pre-header text',
      copySubjectLine: 'Copy subject line',
      elementRemoved: 'Element removed.',
      emailPreview: 'Email Preview',
      failedToRemoveElement: 'Failed to remove element.',
      failedToUpdateContent: 'Failed to update content.',
      failedToUpdateImage: 'Failed to update image.',
      failedToUpdateLockOnContent: 'Failed to update the lock on this content.',
      failedToUpdateLockOnImage: 'Failed to update the lock on this image.',
      imageUpdated: 'Image updated.',
      imageUpdatedAndLocked: 'Image updated and locked.',
      lockedAsPartOfALargerSection:
        'Locked as part of a larger section — unlock that section instead.',
      lockedByTheTemplate: 'Locked by the template, so the agent never changes it.',
      preHeaderCopied: 'Pre-header copied!',
      preHeaderText: 'Pre-Header Text',
      subjectLine: 'Subject Line',
      subjectLineCopied: 'Subject line copied!',
    },
    publish: 'Publish',
    publishing: 'Publishing…',
    publishTemplateModal: {
      close: 'Close',
      done: 'Done',
      published: 'Published',
      publishedWithWarnings: 'Published with warnings',
      publishFailed: 'Publish failed',
      publishingArtifact: 'Publishing artifact…',
      publishedToPipelines_one: 'Published to {{count}} pipeline.',
      publishedToPipelines_other: 'Published to {{count}} pipelines.',
      publishingTemplate: 'Publishing template',
    },
    publishTemplateToRegisteredPipelines: 'Publish template to registered pipelines',
    save: 'Save',
    saveTemplate: 'Save template',
    useArtifactSave: {
      failedToSaveTemplate: 'Failed to save template',
      templateSavedSuccessfully: 'Template saved successfully',
    },
    useEmailActions: {
      emailTemplateCopied: 'Email template copied to clipboard',
      emailTemplateDownloaded: 'Email template downloaded successfully',
      failedToCopyEmailTemplate: 'Failed to copy email template',
      failedToDownloadEmailTemplate: 'Failed to download email template',
    },
  },
  ideationWidget: {
    back: 'Back',
    asyncImage: {
      loading: 'Loading {{alt}}',
    },
    benchmarkCard: {
      agencyUnknown: 'Agency Unknown',
      brandAgencyAndYear: 'Brand, Agency, and Year',
      exploreCase: 'Explore case',
      type: {
        cliches: 'Clichés',
        disruptiveStunt: 'Disruptive Stunt',
      },
      universalTruth: 'Universal Truth',
    },
    benchmarkCarousel: {
      getInspiredByBenchmarkReferences: 'Get inspired by benchmark references',
    },
    campaignHeader: {
      campaignImagesCollage: 'Campaign images collage',
      creativeMission: 'Creative mission',
      mainCampaignImage: 'Main campaign image',
    },
    carouselControls: {
      goToSlide: 'Go to slide {{slide}}',
      nextSlide: 'Next slide',
      previousSlide: 'Previous slide',
    },
    constraintsGrid: {
      campaignConstraints: 'Campaign constraints',
      constraints: 'Constraints',
    },
    creativeOverview: 'Creative overview',
    downloadReport: 'Download report',
    executionDetailCard: {
      visualForExecution: 'Visual for {{title}} execution',
      bestFitPlatform: 'Best fit platform',
      executionNumber: 'Execution {{executionNumber}}',
      noImageAvailable: 'No image available',
      recommendedPlatforms: 'Recommended platforms',
    },
    ideaDetailHeader: {
      visualRepresentationOf: 'Visual representation of {{title}}',
      noImageAvailable: 'No image available',
    },
    ideaDetailPanel: {
      relatedBenchmarks: 'Related Benchmarks',
      score: 'Score',
      strategicContext: 'Strategic Context',
    },
    ideaListPanel: {
      campaignOverview: 'Campaign Overview',
      noIdeasAvailable: 'No ideas available',
    },
    ideasShowcase: {
      audience: 'Audience',
      creativity: 'Creativity',
      exploreIdea: 'Explore idea',
      ideaNumber: 'Idea {{ideaNumber}}',
      kickstartYourThinkingWithThese: 'Kickstart your thinking with these ideas',
      provocation: 'Provocation',
    },
    ideationThumbnail: {
      ideation: 'Ideation',
    },
    descriptionUpdated: 'Description updated',
    failedToDownload: 'Failed to download',
    failedToSaveDescription: 'Failed to save description',
    preparingYourDownload: 'Preparing your download, this may take a moment…',
    saveCampaignToProject: 'Save campaign to project',
    saveIdeaToProject: 'Save idea to project',
    startABrief: 'Start a brief',
    unableToSaveSessionInformation: 'Unable to save: session information missing',
    scoreTabCard: {
      audienceScore: 'Audience score',
      categoriesLabel: '{{title}} categories',
      creativeScore: 'Creative score',
      noDescriptionAvailable: 'No description available for this category.',
    },
    strategicElementsGrid: {
      keyStrategicElements: 'Key strategic elements',
      strategicElementsList: 'Strategic elements list',
    },
    whyItWorksCard: {
      whyItWorks: 'Why it works',
    },
  },
  imageWidget: {
    all: 'All',
    image: 'Image',
    imageEditor: {
      circle: 'Circle',
      clear: 'Clear',
      close: 'Close',
      editSelection: 'Edit Selection',
      freeDraw: 'Free draw',
      gesture: 'Gesture',
      rectangle: 'Rectangle',
    },
    imageCard: {
      download: 'Download',
      edit: 'Edit',
      imageActions: 'Image actions',
      loadingImage: 'Loading image\u2026',
      reference: 'Reference',
      removeReference: 'Remove reference',
    },
    imageMask: {
      imageEditMask: 'Image edit mask',
    },
    infoMenu: {
      aspectRatio: 'Aspect Ratio',
      customModelId: 'Custom Model ID',
      date: 'Date',
      model: 'Model',
      prompt: 'Prompt',
      referenceImages: 'Reference Images',
      resolution: 'Resolution',
      size: 'Size',
    },
    noDataProvidedForImageWidget: 'No data provided for ImageWidget',
    viewPromptInfo: 'View prompt info',
  },
  loremIpsumWidget: {
    generatedParagraphs_one: 'Generated {{count}} paragraph of test content',
    generatedParagraphs_other: 'Generated {{count}} paragraphs of test content',
    loremIpsum: 'Lorem Ipsum',
    loremIpsumTestWidgetFor: 'Lorem Ipsum Test Widget • For Testing & Development',
    loremIpsumWidget: 'Lorem Ipsum Widget',
    noDataProvidedForLorem: 'No data provided for Lorem Ipsum Widget',
    styleLabel: '{{style}} Style',
    test: 'Test',
    wordCount: '{{wordCount}} words',
  },
  socialBriefWidget: {
    brandContextSection: {
      brandContext: 'Brand Context',
      competitiveMentions: 'Competitive Mentions',
      creativeGuidance: 'Creative Guidance',
      brandMentions: '{{brandName}} Mentions',
      keyMessagesClientPovAlignment: 'Key Messages (Client POV / Alignment)',
      outlinesHowTheBrandShows:
        'Outlines how the brand shows up in the world and how is perceived today',
      style: 'Style',
      toneOfVoice: 'Tone of Voice',
    },
    closeWidget: 'Close Widget',
    copyContent: 'Copy Content',
    creativeBriefSnapshotSection: {
      cognitionIcon: 'Cognition Icon',
      creativeBriefSnapshot: 'Creative Brief Snapshot',
      providesAQuickOverviewOf: "Provides a quick overview of the brief's most important elements",
      recommendedFormats: 'Recommended Formats',
      referencesCitations: 'References & Citations',
      suggestedMessagingStarters: 'Suggested Messaging Starters',
    },
    customerUnderstandingSection: {
      culturalContext: 'Cultural Context',
      customerUnderstanding: 'Customer Understanding',
      popCultureEventAnchors: 'Pop Culture/Event Anchors',
      segments: 'Segments',
      targetAudienceDemandSpace: 'Target Audience / Demand Space',
      understandingOfTheCustomerTo:
        'Understanding of the customer to ensure the brief is rooted in real insight and relevance.',
    },
    detailSectionItem: {
      sourceCount_one: '{{count}} Source',
      sourceCount_other: '{{count}} Sources',
    },
    invalidDataProvidedForSocialBriefWidget: 'Invalid data provided for SocialBriefWidget',
    measurementAndActivationSection: {
      assetTypeNeedS: 'Asset Type Need(s)',
      assumptionsFlags: 'Assumptions / Flags',
      measurementActivation: 'Measurement & Activation',
      outlinesHowSuccessWillBe:
        'Outlines how success will be measured and how the idea will come to life',
      platformRecommendation: 'Platform Recommendation',
      primary: 'Primary:',
      rationale: 'Rationale:',
      secondary: 'Secondary:',
    },
    noDataProvidedForSocialBriefWidget: 'No data provided for SocialBriefWidget',
    opportunitySection: {
      opportunity: 'Opportunity',
      overviewOfTheSelectedOpportunity: 'Overview of the selected opportunity',
      trend: 'Trend',
      trendInsight: 'Trend Insight',
      trendOrigin: 'Trend Origin',
      widgetIcon: 'Widget Icon',
    },
    overviewSection: {
      brandRelevance: 'Brand Relevance',
      dateDetected: 'Date Detected',
      description: 'Description',
      opportunity: 'Opportunity',
      overview: 'Overview',
      sourceCount_one: '{{count}} source',
      sourceCount_other: '{{count}} sources',
      sourcePosts: 'Source Posts',
      title: 'Title',
      trendSummary: 'Trend Summary',
      whyItMattersToThe: 'Why it matters to the Brand',
    },
    socialBriefThumbnail: {
      socialBrief: 'Social Brief',
    },
    socialBriefWidgetUtils: {
      assetTypeNeeds: 'Asset Type Needs',
      assumptionsFlags: 'Assumptions & Flags',
      brandMentions: 'Brand Mentions',
      brandRelevance: 'Brand Relevance:',
      citationTags: 'Citation Tags',
      creativeGuidance: 'Creative Guidance:',
      detected: 'Detected: {{date}}',
      keyMessages: 'Key Messages',
      opportunity: 'Opportunity:',
      opportunityDescription: 'Opportunity Description:',
      platformRecommendations: 'Platform Recommendations',
      rationales: 'Rationales:',
      references: 'References',
      socialBrief: '{{brand}} Social Brief',
      source: 'Source: {{source}}',
      sources: 'Sources:',
      styles: 'Styles:',
      targetAudience: 'Target Audience',
      whyItMattersToTheBrand: 'Why It Matters to the Brand',
    },
    socialMediaBrief: 'Social Media Brief',
    useBriefActions: {
      failedToCopyMarkdown: 'Failed to copy markdown to clipboard',
      markdownCopied: 'Markdown copied to clipboard',
    },
    whyItMattersSection: {
      clarifyTheRelevanceBehindThis:
        'Clarify the relevance behind this brief and its significance to your brand.',
      docLabel: '[Doc] {{fileName}}',
      otherSource: 'Other source',
      postLabel: '[Post] {{title}}',
      untitledPost: 'Untitled Post',
      whyThisMattersForYour: 'Why this matters for your brand',
    },
  },
  videoWidget: {
    downloadVideo: 'Download video',
    html5Player: {
      enterFullscreen: 'Enter fullscreen',
      exitFullscreen: 'Exit fullscreen',
      mute: 'Mute',
      pause: 'Pause',
      play: 'Play',
      seek: 'Seek',
      unmute: 'Unmute',
    },
    infoMenu: {
      date: 'Date',
      fileName: 'File name',
      mimeType: 'MIME type',
      model: 'Model',
      prompt: 'Prompt',
      referenceImages: 'Reference Images',
      size: 'Size',
    },
    noVideoUrlProvided: 'No video URL provided.',
    video: 'Video',
    viewPromptInfo: 'View prompt info',
  },
  widget: {
    infoMenu: {
      close: 'Close',
      promptInfo: 'Prompt info',
    },
    sourcePopover: {
      nextSource: 'Next source',
      previousSource: 'Previous source',
      sourceCount_one: '{{count}} Source',
      sourceCount_other: '{{count}} Sources',
      sources: 'Sources',
    },
    useWidgetVersions: {
      brief: 'Brief',
      briefing: 'Briefing',
      copy: 'Copy',
      email: 'Email',
      generatedImage: 'Generated Image',
      generatedVideo: 'Generated Video',
      widget: 'Widget',
      image: 'Image',
      insight: 'Insight',
      opportunities: 'Opportunities',
      social: 'Social',
      strategicTerritories: 'Strategic Territories',
      strategy: 'Strategy',
      version: 'Version {{version}}',
      video: 'Video',
    },
  },
} as const;
